export default __webpack_public_path__ + "static/media/navbar-icon-product-report.75fc624e.svg";